import _ from 'lodash';
import baseTheme from '../base';
import themeStrings from './strings.json';
import logoUri from './images/logo.svg';
import faviconUri from './images/favicon.png';
import leftChevron from './icons/leftChevron.svg';
import rightChevron from './icons/rightChevron.svg';
import link from './icons/link.svg';
import close from './icons/close.svg';

const palette = {
  blue: '#006699',
  lightBlue: '#3C81BE',
  black: '#1D1D1B',
  dark: '#0077B3',
  darkGrey: '#7c7c7c',
  grey: '#696969',
  lightGrey: '#d8d7d9',
  lightestGrey: '#F3F0EF',
  darkestGrey: '#333333',
  green: 'green'

};

const colours = {
  primary: palette.blue,
  accent: palette.black,
  link: palette.blue,
  bg: palette.lightestGrey,
  bgContrast: 'white',
  black: palette.grey,
  muted: palette.darkGrey,
  border: palette.lightGrey,
  hover: palette.lightestGrey,
  positive: palette.green,
  alert: palette.blue,
  dark: palette.dark,
  toggleTrack: palette.blue,
  banner: {
    background: palette.darkestGrey,
    primary: 'white',
    secondary: '#adadad'
  }
};

const borders = {
  radius: '2px',
  box: `1px solid ${colours.border}`
};

const gutters = {
  horizontal: '10px'
};

const assets = {
  brand: logoUri,
  favicon: faviconUri
};

const icons = {
  leftChevron,
  rightChevron,
  link,
  close
};

const whitespace = {
  xs: '5px',
  small: '10px',
  base: '15px',
  large: '20px',
  xl: '30px',
  gutter: '10px'
};

const type = {
  base: {
    fontFamily: 'TimesDigital',
    fontSize: '16px',
    lineHeight: '24px',
    color: colours.black,
    fontWeight: 'normal',
    fontStyle: 'normal',
    letterSpacing: 'normal',
    textAlign: 'left'
  },
  h1: {
    fontFamily: 'TimesModern',
    fontSize: '26px',
    fontWeight: 'bold',
    color: colours.black,
    margin: 0,
    marginBottom: whitespace.xs,
    padding: 0,
    letterSpacing: '0.01em'
  },
  h2: {
    fontFamily: 'TimesModern',
    fontSize: '20px',
    lineHeight: '26px',
    fontWeight: 'bold',
    color: palette.black,
    margin: `${whitespace.xs} 0`
  },
  modal:{
    borderRadius:'4px'
  },
  modalh2: {
    fontFamily: 'TimesModern',
    margin: 0,
    padding: 0,
    lineHeight: '1em',
    textAlign: 'center',
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#1d1d1b'
  },  
  h3: {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    lineHeight: 'auto',
    fontWeight: 'normal',
    color: colours.primary,
    margin: 0,
    padding: 0
  },
  small: {
    fontFamily: 'sans-serif',
    fontSize: '14px',
    lineHeight: '22px',
    color: colours.muted
  },
  button: {
    fontFamily: 'sans-serif',
    fontSize: '15px'
  },
  link: {
    fontFamily: 'sans-serif',
    color: colours.link,
    textDecoration: 'underline',
    fontSize: '16px',
    cursor: 'pointer'
  },
  linkBlock: {
    textAlign: 'center',
    fontSize: '16px'
  },
  notice: {
    fontFamily: 'sans-serif',
    textAlign: 'center',
    fontSize: '14px'
  }
};
const strings = _.merge(themeStrings, {
  product: {
    newsletter: {
      uri: 'https://home.thetimes.co.uk/myNews'
    },
    faq: {
      uri:
        'https://www.thetimes.co.uk/help/articles/communication-preferences'
    }
  },
  analytics: {
    tag: 'thetimes.marketingpreferencecentre'
  }
});

export default _.merge({}, baseTheme, {
  colours,
  assets,
  whitespace,
  type,
  icons,
  borders,
  gutters,
  strings
});
